import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=46aba23c&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=46aba23c&prod&scoped=true&lang=css"
import style1 from "./Welcome.vue?vue&type=style&index=1&id=46aba23c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aba23c",
  null
  
)

export default component.exports